import { FunctionComponent } from 'react';
import { JsonView, collapseAllNested } from 'react-json-view-lite';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  DesktopLayoutDefaultContentHeader,
  FixedInfoBanner,
  Text,
} from '@kanda-libs/ks-design-library';

import JobBanner from 'components/job/JobLayout/JobBanner';
import JobCompanyDetails from 'components/job/JobLayout/JobCompanyDetails';
import JobCustomerDetails from 'components/job/JobLayout/JobCustomerDetails';
import JobFinanceOptions from 'components/job/JobLayout/JobFinanceOptions';
import JobLineItems from 'components/job/JobLayout/JobLineItems';
import JobPayments from 'components/job/JobLayout/JobPayments';
import JobSatNote from 'components/job/JobLayout/JobSatNote';

import JobNotes from './JobNotes';
import JobWorkType from './JobWorkType';
import useBanner from './useBanner';

const JobLayout: FunctionComponent = function () {
  const { job, lenderCopy, ...fixedInfoBannerProps } = useBanner();
  return (
    <>
      <FixedInfoBanner {...fixedInfoBannerProps}>
        <Text text={lenderCopy} className="text-20-24-em p-3" />
      </FixedInfoBanner>
      <DesktopLayoutDefault>
        <DesktopLayoutDefaultContentHeader>
          <JobBanner />
        </DesktopLayoutDefaultContentHeader>
        <DesktopLayoutDefaultContent>
          <div className="flex flex-col">
            <div className="flex flex-row mb-6">
              <div className="flex flex-col w-1/2 mr-6">
                <JobCompanyDetails />
              </div>
              <div className="flex flex-col w-1/2">
                <JobCustomerDetails />
              </div>
            </div>
            <div className="flex flex-row">
              <div className="flex flex-col w-1/2 mr-6">
                <JobLineItems />
                <JobNotes />
                <JobWorkType />
                <JobFinanceOptions />
              </div>
              <div className="flex flex-col w-1/2">
                <JobPayments />
                <JobSatNote />
              </div>
            </div>
            {job ? (
              <>
                <p className="mt-10 mb-6 text-20-24-em">Job JSON</p>
                <JsonView data={job} shouldExpandNode={collapseAllNested} />
              </>
            ) : null}
          </div>
        </DesktopLayoutDefaultContent>
      </DesktopLayoutDefault>
    </>
  );
};

export default JobLayout;
